import { useState } from 'react';
import { validateForm } from '../utils/validators';
import { useLanguage } from '../context/LanguageContext';

export const useFormValidation = (initialData) => {
    const { t } = useLanguage();
    const [formData, setFormData] = useState(initialData);
    const [errors, setErrors] = useState({});

    const handleChange = (name, value) => {
        const newFormData = { ...formData, [name]: value };
        setFormData(newFormData);

        const formErrors = validateForm(newFormData, t);

        if (formErrors[name]) {
            setErrors(prev => ({ ...prev, [name]: formErrors[name] }));
        } else {
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validate = () => {
        const newErrors = validateForm(formData, t);
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setFormData(initialData);
        setErrors({});
    };

    const setFieldError = (field, error) => {
        setErrors(prev => ({ ...prev, [field]: error }));
    };

    const clearErrors = () => {
        setErrors({});
    };

    return {
        formData,
        errors,
        handleChange,
        validate,
        resetForm,
        setFieldError,
        clearErrors,
        setFormData
    };
};
